import {AbstractAnimation} from '../animations/AbstractAnimation';
import {DPlexArguments} from '../DPlexArguments';

export abstract class AbstractTransition {

    protected modalEnter=false;
    protected modalLeave=false;
    protected animation?:AbstractAnimation;
    protected playDelay=0;
    protected promises:Promise<any>[]=[];

    [key: string]: any;

    constructor(protected args:DPlexArguments) {
        if (args.enter.hasClass('modal')) this.modalEnter=true;
        if (args.leave.hasClass('modal')) this.modalLeave=true;
        return new Proxy(this, {
            get: (target,prop,receiver)=>this.getHandler(target,prop,receiver),
            has: (target,prop)=>this.hasHandler(target,prop)
        });
    }

    protected getHandler(target:object,prop:string|symbol,receiver:any) {
        if (Reflect.has(target,prop)) return Reflect.get(target,prop,receiver);
        if (this.animation && Reflect.has(this.animation,prop)) {
            return Reflect.get(this.animation,prop);
        }
    }

    protected hasHandler(target:object,prop:string|symbol) {
        if (Reflect.has(target,prop)) return Reflect.has(target,prop);
        if (this.animation && Reflect.has(this.animation,prop)) {
            return Reflect.has(this.animation,prop);
        }
        return false;
    }

    public with(...args: Promise<any>[]) {
        this.promises.push(...args);
        return this;
    }

    public play():AbstractAnimation|Promise<any>|void {
        if (!this.animation) return;
        if (this.promises.length) {
            this.before();
            return Promise.all([...this.promises,this.animation.play()]).then(()=>{this.after();});
        }

        this.animation.on('begin',()=>{this.before();});
        this.animation.on('end',()=>{this.after();});
        if (this.playDelay) {
            setTimeout(()=>this.animation?.play(),this.playDelay);
        } else {
            this.animation.play();
        }
        return this.animation;
    }

    public before() {
    }

    public after() {
        this.args.enter.trigger('enter',this.args);
        this.args.leave.trigger('leave',this.args);
        $('body').focus();
    }

}

export {};